import { render, staticRenderFns } from "./SelecionarClienteDialog.vue?vue&type=template&id=15e54f42&"
import script from "./SelecionarClienteDialog.vue?vue&type=script&lang=js&"
export * from "./SelecionarClienteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports